export const useGTM = () => {
    const setup = () => {
        const gtmId = import.meta.env.VITE_GTM_GTAG_ID;
        const gtmUrl = import.meta.env.VITE_GTM_SCRIPT_URL;

        if (!gtmId) return;
        if (!gtmUrl) return;

        // Inject GTM script in head
        const script = document.createElement("script");
        script.setAttribute("data-type", "application/javascript");
        script.setAttribute("type", "text/plain");
        script.setAttribute("data-name", "google-tag-manager");
        script.text = `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
            var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
            j.async=true;
            j.src='${gtmUrl}?id='+i+dl;
            f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer', '${gtmId}');
        `;
        document.head.appendChild(script);

        // Inject noscript iframe in body
        const noscript = document.createElement("noscript");
        const iframe = document.createElement("iframe");
        iframe.setAttribute("data-name", "google-tag-manager");
        iframe.setAttribute("data-src", `https://www.googletagmanager.com/ns.html?id=${gtmId}`);
        iframe.setAttribute("height", "0");
        iframe.setAttribute("width", "0");
        iframe.style.display = "none";
        iframe.style.visibility = "hidden";
        noscript.appendChild(iframe);
        document.body.appendChild(noscript);
    };

    return { setup };
};
